import React from 'react';
import { AuthSignInForm, AuthTwoFactorForm } from './sign-in-form';
import { useCompanySignInSubmit } from '../hooks';

interface SignInBodyProps {
    onSuccess?: () => void;
}

export const SignInBody: React.FC<SignInBodyProps> = ({ onSuccess }) => {
    const { signInSubmit, isTwoFactorStep, verify, twoFactorType } = useCompanySignInSubmit();

    return isTwoFactorStep ? (
        <AuthTwoFactorForm request={verify} twoFactorType={twoFactorType} />
    ) : (
        <AuthSignInForm request={signInSubmit} onSuccess={onSuccess} />
    );
};
